// Active-subscription Query (Query-owned server-state per STATE_POLICY)
export {
  useActiveSubscription,
  getActiveSubscriptionSnapshot,
  useSubscriptionNotificationsStore,
} from './model';
export type {
  ActiveSubscriptionData,
  EffectivePlan,
  Usage,
  SubscriptionNotification,
  SubscriptionLimits,
} from './model';

// Selector exports
export {
  useSubscription,
  usePlan,
  useUsage,
  useIsGuestMode,
  useEffectivePlan,
  useTokenBalance,
  useTokenBalanceInitialized,
  useSubscriptionLoading,
  useSubscriptionError,
  useSubscriptionNotifications,
  useIsDataLoaded,
  useRemainingGenerations,
  useRemainingTokens,
  useSubscriptionLimits,
  useSubscriptionStatus,
  useSubscriptionActions,
  useHasFeature,
  useIsSubscriptionActive,
  useCheckLimit,
  useNeedsUpgrade,
  usePlanTier,
} from './model';

// UI exports
export { SubscriptionGate } from './ui/SubscriptionGate';
export { default as SubscriptionNotifications } from './ui/SubscriptionNotifications';

export { UpgradePrompt } from './ui/UpgradePrompt';

// Lib exports
export { WEB_NATIVE_PROVIDERS, isWebNativeProvider } from './lib/provider-helpers';

// API exports
export { subscriptionService } from './api/subscriptions';
